import { useTranslation } from 'react-i18next';
import { ActionIcon, Menu, useMantineTheme } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';

interface LanguageOption {
  value: string;
  label: string;
  icon: string;
}

export const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const theme = useMantineTheme();
  const isDark = theme.colors.dark != null;

  const languages: LanguageOption[] = [
    { value: 'en', label: t('language.en'), icon: '🇬🇧' },
    { value: 'es', label: t('language.es'), icon: '🇪🇸' },
  ];

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  const currentLanguage = languages.find(lang => lang.value === i18n.language);

  return (
    <Menu
      shadow="md"
      width={120}
      styles={theme => ({
        item: {
          '&[data-hovered]': {
            backgroundColor: isDark ? theme.colors.dark[5] : theme.colors.gray[0],
          },
        },
      })}
    >
      <Menu.Target>
        <ActionIcon variant="transparent" color="blue" size="lg">
          {currentLanguage?.icon || <IconLanguage size={20} />}
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        {languages.map(lang => (
          <Menu.Item
            key={lang.value}
            onClick={() => handleLanguageChange(lang.value)}
            leftSection={<span>{lang.icon}</span>}
          >
            {lang.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
